import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailer_pos-logged_in_footer_banner-click';

/**
 * Logged in user clicked the POS banner on page footer
 */
export function trackRetailerPosLoggedInFooterBannerClick(
  Segment: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Segment },
  });
}
